import { BadgeAlertIcon } from 'lucide-react'

interface ReviewDescriptionProps {
  description?: string
  showAlert?: boolean
}

const ReviewDescription = ({ description, showAlert = true }: ReviewDescriptionProps) => {
  return (
    <div className="flex flex-col gap-2 py-2">
      {showAlert && (
        <div className="flex items-center gap-1.5 text-warning">
          <BadgeAlertIcon size={20} strokeWidth={1} />

          <span className="font-bold text-sm">Revisão solicitada</span>
        </div>
      )}

      {description && (
        <div className="bg-yellow-op-2 rounded-md p-4 w-full h-36 text-white-800 text-sm overflow-y-auto">
          <p data-testid="requested_review_description">{description}</p>
        </div>
      )}
    </div>
  )
}

export default ReviewDescription
